<script lang="ts" setup>
import InfoCard from '@/home/components/InfoCard.vue';
import { $fetch } from '@/home/plugins/fetch';
import useMarkdown from '@/home/hooks/markdown';
import { useAsyncData } from '@/home/hooks/async-data';

const marked = useMarkdown();

const { data: summaryList } = useAsyncData(
  'law:licence:summary',
  () => $fetch('/law/resource/v1/list', {
    data: {
      category: import.meta.env.VITE_LAW_LICENCE_CATEGORY_ID1,
      limit: -1,
    },
  }),
);

const { data: licenceList } = useAsyncData(
  'law:licence:listing',
  () => $fetch('/law/resource/v1/list', {
    data: {
      category: import.meta.env.VITE_LAW_LICENCE_CATEGORY_ID2,
      limit: -1,
    },
  }),
);
</script>

<template>
  <div class="page-law-licence">
    <template v-if="summaryList?.length">
      <template v-for="item in summaryList" :key="item.title">
        <h2 class="m-0 text-center text-32px color-hex-2d2d2d font-medium leading-48px">{{ item.title }}</h2>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="markdown mt-32px text-16px color-hex-2d2d2d font-normal leading-24px" v-html="marked.parse(item.content)"></div>
      </template>
    </template>

    <div v-if="licenceList?.length">
      <ul class="paragraph-ul m-0 p-0">
        <li v-for="item in licenceList" :key="item.title" class="m-0 mt-48px list-none p-0">
          <InfoCard :title="item.title">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="markdown description" v-html="marked.parse(item.content)"></div>
          </InfoCard>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-law-licence {
  .markdown {
    &:deep() {
      a {
        color: #1180ff;
        text-decoration: none;
        list-style: none;
      }
    }
  }

  .paragraph-ul {
    .description {
      &:deep() {
        p {
          @apply mb-0 mt-1.2em text-16 font-normal leading-24 color-#2d2d2d;
        }

        h3 {
          @apply text-18 mb-8 mt-32 font-500 color-#2d2d2d first:mt-16;
        }

        em {
          @apply color-#2d2d2d not-italic;
        }
      }
    }
  }
}
</style>
